import {
  getVendorBiddingDetail,
  getVendorBiddingDraftDetail,
} from "@/apis/inquiry.api";
import { useQuery } from "@tanstack/react-query";

export function useVendorBiddingDetailQuery(id: string | null) {
  const { data } = useQuery({
    queryKey: ["vendorBiddingDetail", id],
    queryFn: () => {
      if (id === null) {
        throw new Error("Vendor bidding ID is required");
      }
      return getVendorBiddingDetail(id);
    },
    enabled: id !== null,
  });

  return data?.data.data;
}

export function useVendorBiddingDraftDetailQuery() {
  const { data } = useQuery({
    queryKey: ["vendorBiddingDraftDetail"],
    queryFn: () => getVendorBiddingDraftDetail(),
  });

  return data?.data.data;
}
